<template>
  <div id="hawthorn_content">
    <!-- 左侧区域 -->
    <div class="left_content">
      <div class="left_img">
        <div class="lingshi_one">
          <img src="../assets/images/零食1.png" alt />
        </div>
        <div class="lingshi_two">
          <img src="../assets/images/零食2.png" alt />
        </div>
      </div>
      <div class="right_img">
        <div class="lingshi_one">
          <img src="../assets/images/零食3.png" alt />
        </div>
        <div class="lingshi_two">
          <img src="../assets/images/零食4.png" alt />
        </div>
      </div>
    </div>
    <!-- 右侧区域 -->
    <div class="right_content">
      <!-- header图片 -->
      <div class="header_img">
        <img src="../assets/images/零食标题.png" alt />
      </div>
      <!-- 文本区域 -->
      <div class="bottom_text">
        <p>八号地的零食滋味鲜浓，香脆可口，严选优质材料，
          保证口感，小麻花低温烘烤，色泽金黄入味道，外
          脆内酥，劲道香脆的口感，让您恋上美食的味道！</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {};
</script>

<style lang="less" scoped>
  #hawthorn_content {
    width: 100%;
    height: 827px;
    padding: 208px 202px 189px 350px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }

  .left_content {
    width: 557px;
    height: 430px;
    display: flex;
    justify-content: space-between;
  }

  .left_content>.left_img {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .left_content>.right_img {
    margin-left: 50px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .left_content>.left_img img {
    width: 280px;
  }

  .left_content>.right_img img {
    width: 100%;
  }

  .right_content {
    width: 812px;
  }
  .right_content > .header_img >img{
    width: 120%;
    height: 158px;
  }
  .bottom_text > p {
    width: 514px;
    height: 194px;
    font-size: 29px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(96, 96, 96, 1);
    line-height: 42px;
    margin: 20px 0 0 98px;
    text-indent: 25px;
    letter-spacing: 5px;
  }
</style>
